const fixedElementToTop = (container, element) => {
    // Get the container and element nodes
    const containerNode = container[0];
    const elementNode = element[0];

    if (!containerNode || !elementNode) {
        return;
    }

    // Get the initial offset of the element relative to the container
    const initialOffset = elementNode.offsetTop - containerNode.offsetTop;

    // Function to handle scroll events on the container
    function handleScroll() {
        // Get the scroll position inside the container
        const scrollPosition = containerNode.scrollTop;

        // Calculate the new position for the element
        const newPosition = scrollPosition - initialOffset;

        // Fix the element on top when scrolling down
        if (newPosition > 0) {
            elementNode.style.position = 'sticky';
            elementNode.style.top = '0';
            elementNode.classList.add('apexchat-stick-to-top');
        } else {
            // Release the sticky position when scrolling up
            elementNode.style.position = 'relative';
            elementNode.style.top = 'auto';
            elementNode.classList.remove('apexchat-stick-to-top');
        }
    }

    // Add scroll event listener to the container
    containerNode.addEventListener('scroll', handleScroll);

    // Cleanup: Remove event listener when no longer needed
    return function cleanup() {
        containerNode.removeEventListener('scroll', handleScroll);
    };
};
export default fixedElementToTop;
